<template>
  <component
    :is="component"
    :to="to"
  >
    <q-card
      flat
      v-bind="$attrs"
      :class="['full-height', cardClass, { 'no-background': noBackground }]"
    >
      <slot name="top-image"/>
      <q-card-section
        v-if="title"
        :class="['q-px-lg', headerColor, {'border-bottom': !noBackground && $slots.default, 'q-pt-none': noBackground}]"
      >
        <div class="flex items-center justify-between q-gutter-x-md">
          <component
            :is="titleRoute ? 'router-link' : 'div'"
            :class="titleClass"
            :to="titleRoute"
          >
            {{ title }}
            <q-tooltip
              v-if="labelTooltip"
              transition-hide="fade"
              transition-show="fade"
              content-class="bg-black text-13-400 q-px-lg q-py-md text-center"
              max-width="300px"
              anchor="bottom right"
              :offset="[-100, 30]"
            >
              {{ title }}
            </q-tooltip>
            <q-icon
              v-if="titleIcon"
              color="primary"
              class="q-ml-sm"
              :name="titleIcon"
              size="18px"
            />
          </component>
          <slot name="titleRight"/>
        </div>
      </q-card-section>
      <div
        v-if="$slots.default"
        :class="[bodyDefaultClass, bodyClass]"
      >
        <slot/>
      </div>
      <q-card-actions
        v-if="$slots.actions"
        :align="actionsAlign"
        class="q-px-lg q-px-md-xl q-py-lg"
      >
        <slot name="actions"/>
      </q-card-actions>
    </q-card>
  </component>
</template>

<script>
export default {
  name: 'AppCard',
  props: {
    title: {
      type: String,
      default: undefined,
    },
    titleIcon: {
      type: String,
      default: undefined,
    },
    titleClass: {
      type: String,
      default: 'text-18-600',
    },
    headerColor: {
      type: String,
      default: undefined,
    },
    cardClass: {
      type: [String, Object],
      default: undefined,
    },
    bodyDefaultClass: {
      type: String,
      default: 'q-pa-none',
    },
    bodyClass: {
      type: String,
      default: undefined,
    },
    noBackground: {
      type: Boolean,
      default: false,
    },
    labelTooltip: {
      type: Boolean,
      default: false,
    },
    actionsAlign: {
      type: String,
      default: undefined,
    },
    to: {
      type: [Object, String],
      default: undefined,
    },
    titleRoute: {
      type: [Object, String],
      default: undefined,
    },
  },
  computed: {
    component() {
      return this.to ? 'router-link' : 'div';
    },
  },
};
</script>
